import React from "react";
import { connect } from "react-redux";
import RootState from "../../../redux/RootState";
import PendingInvite from "../../../rest/invites/model/PendingInvite";
import Organisation from "../../../rest/organisation/model/Organisation";
import OrganisationUser from "../../../rest/organisation/model/OrganisationUser";
import UserDetails from "../../../rest/user/model/UserDetails";
import TableList from "../TableList/TableList";
import OrgUserTableRow from "./components/OrgUserTableRow";

const smallCellWidth = "15vw";

interface ReduxStateProps {
  inviteResent: boolean;
  isAdeyAdmin: boolean;
  currentUserId: string | undefined;
  canDeleteUsers: boolean;
  removingUser: boolean;
}

interface ExternalProps {
  users: OrganisationUser[];
  org?: Organisation;
  onUserClicked?: (user: UserDetails) => void;
  onRemoveUser?: (user: UserDetails, org: Organisation) => void;
}

type Props = ReduxStateProps & ExternalProps;

interface State {
  menuUser: UserDetails | undefined;
  menuInvite: PendingInvite | undefined;
  anchorElement: Element | undefined;
}

class OrgUserTable extends React.Component<Props, State> {
  state = {
    menuUser: undefined,
    menuInvite: undefined,
    anchorElement: undefined,
  };

  render() {
    //JSX Elements
    const items = () => {
      return this.props.users?.map((orgUser) => (
        <OrgUserTableRow
          withMargins={this.props.isAdeyAdmin}
          key={orgUser.user.id}
          user={orgUser}
          org={this.props.org}
          loading={this.props.removingUser}
          smallCellWidth={smallCellWidth}
          onClick={this.props.onUserClicked}
          removeUser={this.props.onRemoveUser}
        />
      ));
    };

    const headerKeys: string[] = ["userTable.emailHeader", "userTable.phoneHeader"];
    const headerTitle: string = "userTable.nameHeader";

    return (
      <TableList
        itemRows={items()}
        headerKeys={headerKeys}
        headerTitle={headerTitle}
        withAction={this.props.isAdeyAdmin}
      />
    );
  }

  onUserMenuPressed = (user: UserDetails, e: Element) => {
    this.setState({ menuUser: user, anchorElement: e, menuInvite: undefined });
  };

  inviteMenuPressHandler = (invite: PendingInvite, e: Element) => {
    this.setState({ menuUser: undefined, anchorElement: e, menuInvite: invite });
  };

  onMenuClosed = () => {
    this.setState({
      menuUser: undefined,
      menuInvite: undefined,
      anchorElement: undefined,
    });
  };

  canBuildMenu = (user: UserDetails) => {
    return this.props.canDeleteUsers && user.id !== this.props.currentUserId;
  };
}

const mapStateToProps = (state: RootState): ReduxStateProps => ({
  removingUser: state.adminOrganisationDetails.isRemovingUserFromOrg,
  isAdeyAdmin: state.adeyAdmin.hasAdminAccess,
  inviteResent: state.pendingInviteMenu.resendInvite.success,
  currentUserId: state.login.currentUserId,
  canDeleteUsers: state.activeOrganisation.permissions.canRemoveActiveOrganisationUsers,
});

export default connect(mapStateToProps)(OrgUserTable);
